export const toGid = (type, id) => {
  if (!type || id == null) {
    throw new Error('Type and/or ID is missing');
  }

  switch (type) {
    case 'Product':
      if (id.startsWith('gid://shopify/Product/')) {
        return id;
      }

      return `gid://shopify/Product/${id}`;
    case 'ProductVariant':
      if (id.startsWith('gid://shopify/ProductVariant/')) {
        return id;
      }

      return `gid://shopify/ProductVariant/${id}`;
    case 'Collection':
      if (id.startsWith('gid://shopify/Collection/')) {
        return id;
      }

      return `gid://shopify/Collection/${id}`;
    case 'Customer':
      if (id.startsWith('gid://shopify/Customer/')) {
        return id;
      }

      return `gid://shopify/Customer/${id}`;
    default:
      throw new Error(`Unsupported Shopify GID type: ${type}`);
  }
};

export const fromGid = (id) => {
  if (id?.includes('gid://shopify/Product/')) {
    return id.split('gid://shopify/Product/')[1];
  } else if (id?.includes('gid://shopify/ProductVariant/')) {
    return id.split('gid://shopify/ProductVariant/')[1];
  } else if (id?.includes('gid://shopify/Collection/')) {
    return id.split('gid://shopify/Collection/')[1];
  } else if (id?.includes('gid://shopify/Customer/')) {
    return id.split('gid://shopify/Customer/')[1];
  }

  return id;
};

export const productGidsMatch = (cmsProductId, shopifyProductId) => {
  if (!cmsProductId || shopifyProductId == null) {
    return false;
  }

  return (
    toGid('Product', cmsProductId) === toGid('Product', shopifyProductId)
  );
};
